export default __webpack_public_path__ + "static/dots-be8c207e4b2021b23e91f72d2e6e4755.svg";